import { render, staticRenderFns } from "./episode-head.vue?vue&type=template&id=00522e86&scoped=true&lang=html&"
import script from "./episode-head.vue?vue&type=script&lang=js&"
export * from "./episode-head.vue?vue&type=script&lang=js&"
import style0 from "./episode-head.vue?vue&type=style&index=0&id=00522e86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00522e86",
  null
  
)

export default component.exports